import { useState } from 'react';
import { TERMINOLOGY } from '@shared/i18n';
import { useCreate, useProductFolders } from '../api/folders.api';
import NameAndProductsDialog, { TNameAndProductsDialogState } from '../components/dialogs/NameAndProductsDialog';

const useNewProductDialog = () => {
  const [nameAndProductsDialogState, setNameAndProductsDialogState] = useState<TNameAndProductsDialogState>();
  const create = useCreate();
  const products = useProductFolders();

  const openNewProductDialog = () => {
    const dialogState: TNameAndProductsDialogState = {
      isOpen: true,
      products,
      onSubmit: async (data) => {
        await create.mutateAsync(
          { name: data.text, sourceProductId: data.products[0] },
          {
            onSuccess: () => setNameAndProductsDialogState({ ...dialogState, isOpen: false }),
          }
        );
      },
    };
    setNameAndProductsDialogState(dialogState);
  };

  const newProductDialog = (
    <NameAndProductsDialog
      title="New product / technical doc"
      nameLabel="Name"
      productsField={{ label: `Clone ${TERMINOLOGY.database.lower} structure from` }}
      setState={setNameAndProductsDialogState}
      state={nameAndProductsDialogState}
    />
  );

  return { openNewProductDialog, newProductDialog };
};

export { useNewProductDialog };
